import React from "react";
import { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';

import SearchBar from "./common/SearchBar";
import Loader from "./common/Loader";

import axios_api from "../Api";
import { API_URL, AUTH_TOKEN } from '../Context';



export default function FormEditAssets({formData, setFormData}){

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();

  const [formErrors, setFormErrors] = useState({});
  const [allAssets, setAllAssets] = useState([]);
  const [loadingAssets, setLoadingAssets] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');

  // Загрузка категорий
  React.useEffect(() => {
    axios_api.get(api_url + '/asset_categories/', {
      headers: {"Authorization": token},
    })
    .then(
      (result) => {
        setCategories(result.data);
      },
      (error) => {
        console.log('Ошибка загрузки категорий:', error);
        setCategories([]);
      }
    );
  }, [api_url, token]);

  // Загрузка доступных материалов с годом эквивалентным году формы
  const loadAllAssets = () => {
    setLoadingAssets(true);

    const params = formData.year ? { "year": formData.year } : {};
    let yearAssets = axios_api.get(api_url + '/assets', {
      headers: {"Authorization": token},
      params: params
    });

    yearAssets.then(
      (result) => {
        setAllAssets(result.data);
        setLoadingAssets(false);
      },
      (error) => {
        console.log(error);
        setAllAssets([]);
        setLoadingAssets(false);
      }
    );
  };

  const handleAddItem = () => {
    setSearchText('');
    setSelectedAssets([]);
    setSelectedCategory('');
    loadAllAssets();
  };

  const handleRemoveItem = (assetId) => {
    let newFormData = structuredClone(formData);
    if (newFormData.assets) {
      newFormData.assets = newFormData.assets.filter(asset => asset.id !== assetId);
      setFormData(newFormData);
    }
  };

  const handleAssetSelection = (assetId) => {
    setSelectedAssets(prev => {
      if (prev.includes(assetId)) {
        return prev.filter(id => id !== assetId);
      } else {
        return [...prev, assetId];
      }
    });
  };

  const handleConfirmAddAssets = () => {
    let newFormData = structuredClone(formData);
    if (!newFormData.assets) {
      newFormData.assets = [];
    }
    
    // Получаем ID уже прикрепленных assets
    const existingAssetIds = newFormData.assets.map(asset => asset.id);
    
    // Добавляем только новые assets
    selectedAssets.forEach(assetId => {
      if (!existingAssetIds.includes(assetId)) {
        const assetToAdd = allAssets.find(asset => asset.id === assetId);
        if (assetToAdd) {
          newFormData.assets.push(assetToAdd);
        }
      }
    });
    
    setFormData(newFormData);
    setSelectedAssets([]);
  };
  

  function saveForm () {
    let params = {
      section: formData.section || "",
      samples_numbers_and_literals: formData.samples_numbers_and_literals || [],
      form_view_mode: formData.form_view_mode,
      assets_ids: formData.assets ? formData.assets.map(asset => asset.id) : [],
    };

    axios_api.put(api_url + `/manage_form/` + formData.id, params, {
      headers: {
        "Authorization": token, 
      }
    })
    .then(
      (result) => {
        console.log("Form assets saved");
        navigate(0)
      },
      (error) => {
        console.log(error);
        setFormErrors(error.response?.data)
      }
    );
  }
  
  

  const assets = formData.assets || [];
  console.log("FormEditAssets - formData:", formData);
  console.log("FormEditAssets - assets:", assets);

  // Строки для списка прикрепленных assets
  let assetRows = assets.map((asset, i) => (
    <tr className="">
      <td>
        {asset.type === 'FILE' && 
          <span className="form-asset form-asset-file text-center mx-1 px-2">{asset.type.toLowerCase() }</span>
        }
        {asset.type === 'LINK' && 
          <span className="form-asset form-asset-link text-center mx-1 px-2">{asset.type.toLowerCase() }</span>
        }
      </td>
      <td>
        {asset.name}
      </td>
      <td>
        {asset.type === 'FILE' && 
          <a href={asset.file} target="_blank" rel="noopener noreferrer" className="text-truncate d-inline-block" style={{maxWidth: '250px'}}>
            {asset.file}
          </a>
        }
        {asset.type === 'LINK' && 
          <a href={asset.link} target="_blank" rel="noopener noreferrer" className="text-truncate d-inline-block" style={{maxWidth: '250px'}}>
            {asset.link}
          </a>
        }        
      </td>
      <td>
        <button 
          type="button"
          className="btn editor-button m-1" 
          onClick={(e) => {
            e.preventDefault();
            handleRemoveItem(asset.id);
          }}
          title="Удалить материал"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" className="bi bi-x-square" viewBox="0 0 17 17">
            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
          </svg>
        </button>
      </td>
    </tr>
  ));

  // Строки для модального окна выбора assets
  const existingAssetIds = assets.map(asset => asset.id);
  let modalAssetRows = [];

  for (let asset of allAssets) {
    // Фильтрация по названию
    if (searchText && asset.name.toLowerCase().indexOf(searchText.toLowerCase()) === -1) {
      continue;
    }
    
    // Фильтрация по категории
    if (selectedCategory) {
      const assetCategoryId = typeof asset.category === 'object' && asset.category !== null 
        ? asset.category.id 
        : asset.category;
      
      if (assetCategoryId !== parseInt(selectedCategory)) {
        continue;
      }
    }
    
    const isAlreadyAttached = existingAssetIds.includes(asset.id);
    const isSelected = selectedAssets.includes(asset.id);
    
    modalAssetRows.push(
      <div 
        key={asset.id} 
        className={`p-2 border-bottom ${isAlreadyAttached ? 'bg-light text-muted' : ''}`}
      >
        <div className="form-check">
          <input 
            className="form-check-input" 
            type="checkbox" 
            id={`asset-${asset.id}`}
            checked={isSelected}
            onChange={() => handleAssetSelection(asset.id)}
            disabled={isAlreadyAttached}
          />
          <label className="form-check-label w-100" htmlFor={`asset-${asset.id}`}>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex">
                {asset.type === 'FILE' && 
                  <span className="form-asset form-asset-file text-center mx-2">{asset.type}</span>
                }
                {asset.type === 'LINK' && 
                  <span className="form-asset form-asset-link text-center mx-2">{asset.type}</span>
                }
                <strong>{asset.name}</strong>
                {/*asset.type === 'LINK' && asset.link && (
                  <div className="d-flex align-items-center">
                    <small className="text-muted text-truncate mx-3" style={{maxWidth: '400px'}}>
                      {asset.link}
                    </small>
                  </div>
                )**/}                
              </div>
              {isAlreadyAttached && (
                <span className="badge bg-primary me-3">Прикреплен</span>
              )}
            </div>

          </label>
        </div>
      </div>
    );
  }

  console.log(formErrors)


  return (
    <>
      <div className="row">
        <h3 className="m-3">Материалы формы <span className="ms-2">{formData.form_code}</span></h3>
      </div>
      <div className='m-3'>
        <div className="lk-form">
          <form>
            <div className="mb-2">
              {assets.length > 0 ? (
                <>
                  <div className="row mb-2">
                    <div className="col-9">
                      <table className="table">
                        <thead>
                          <tr>
                            <th className="ps-3">Тип</th>
                            <th className="">Название</th>
                            <th className="">Материал</th>
                            <th className="">Действия</th>
                          </tr>
                        </thead>
                        <tbody>
                          {assetRows}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              ) : (
                <p className="text-muted">Материалы не прикреплены</p>
              )}
            </div>
            <div className="input-group">
              <button 
                className="btn editor-button ms-0 mt-2" 
                onClick={(e) => {
                  e.preventDefault(); 
                  handleAddItem();
                }}
                data-bs-toggle="modal"
                data-bs-target="#addAssetsModal"
                title="Прикрепить материал"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-plus-square" viewBox="0 0 17 17">
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                </svg>
              </button>
            </div>
            { Object.keys(formErrors).length > 0 ?
                <p className="text-danger">{JSON.stringify(formErrors)}</p>
              :
                <></>
            }
            <div className="input-group">          
              <button type="button" onClick={saveForm} className="btn lk-button mt-4">Сохранить</button>
            </div>  
          </form>
        </div>               
      </div>

      {/* Модальное окно для выбора assets */}
      <div 
        className="modal fade" 
        id="addAssetsModal" 
        tabIndex="-1" 
        aria-labelledby="addAssetsModalLabel" 
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header bg-light">
              <h2 className="modal-title fs-5" id="addAssetsModalLabel">Выбор материалов</h2>
              <button type="button" className="btn-close me-3" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body mx-4 mb-4">
              {loadingAssets ? (
                <Loader />
              ) : (
                <>
                  <div className="d-flex gap-3 mb-3 align-items-end">
                    <div className="flex-grow-1">
                      <SearchBar
                        searchText={searchText}
                        onSearchtextChange={setSearchText}
                      />
                    </div>
                    <label className="form-label">Категория</label>
                    <div>
                      <select 
                        className="lk-select form-select" 
                        value={selectedCategory} 
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        //style={{width: '250px'}}
                      >
                        <option value="">Все категории</option>
                        {categories.map(category => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div style={{maxHeight: '500px', overflowY: 'auto'}}>
                    {modalAssetRows.length > 0 ? (
                      modalAssetRows
                    ) : (
                      <p className="text-muted text-center">Материалы не найдены</p>
                    )}
                  </div>
                  {/*selectedAssets.length > 0 && (
                    <div className="alert alert-primary w-50 mt-3">
                      Выбрано материалов: {selectedAssets.length}
                    </div>
                  )**/}
                </>
              )}
            </div>
            <div className="modal-footer justify-content-between bg-light">
              <button 
                type="button" 
                className="btn btn-secondary lk-bootstrap-button" 
                data-bs-dismiss="modal"
              >
                Отмена
              </button>
              <button 
                type="button" 
                className="btn lk-button lk-bootstrap-button" 
                data-bs-dismiss="modal" 
                aria-label="Close" 
                onClick={handleConfirmAddAssets}
                disabled={selectedAssets.length === 0}
              >
                Прикрепить ({selectedAssets.length})
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}